module.exports = __webpack_public_path__ + "img/club_house.14cd484a.jpg";